"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const shared_1 = require("../shared");
const react_router_dom_1 = require("react-router-dom");
const userReportApi_1 = require("../services/userReportApi");
const x_data_grid_1 = require("@mui/x-data-grid");
const FlagOutlined_1 = __importDefault(require("@mui/icons-material/FlagOutlined"));
const styles_1 = require("@mui/material/styles");
const diagnosticApi_1 = require("../services/diagnosticApi");
const RemoveRedEye_1 = __importDefault(require("@mui/icons-material/RemoveRedEye"));
const Review_1 = __importDefault(require("./Review"));
const TestScreen_1 = __importDefault(require("./TestScreen"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const mammoth_1 = __importDefault(require("mammoth"));
const XLSX = __importStar(require("xlsx"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const StyledDataGrid = (0, styles_1.styled)(x_data_grid_1.DataGrid)((theme) => ({
    '& .MuiDataGrid-sortIcon': {
        opacity: 1,
        color: 'white',
    },
    '& .MuiDataGrid-menuIconButton': {
        opacity: 1,
        color: 'white',
    },
}));
const FlaggedQuestions = () => {
    const { userId } = (0, react_router_dom_1.useParams)();
    const { data: userReportList, isLoading, refetch } = (0, userReportApi_1.useUserReportListQuery)(userId);
    const [questionsList, setQuestionsList] = (0, react_1.useState)([]);
    const [anchorEl, setAnchorEl] = react_1.default.useState(null);
    const [selectedParam, setSelectedParam] = react_1.default.useState([]);
    const [updateQuestions, setUpdateQuestions] = react_1.default.useState([]);
    const [addFlaggedQuestion] = (0, diagnosticApi_1.useFlaggedQuestionMutation)();
    const [alertOpen, setAlertOpen] = react_1.default.useState(false);
    const [alertMessage, setAlertMessage] = react_1.default.useState('');
    const [alertType, setAlertType] = react_1.default.useState('info');
    const [selected, setSelected] = react_1.default.useState({});
    const [selectedTest, setSelectedTest] = react_1.default.useState({});
    const [takeTestSelected, setTakeTestSelected] = react_1.default.useState(false);
    const [selectedQuiz, setSelectedQuiz] = react_1.default.useState({});
    const [showReview, setShowReview] = react_1.default.useState(false);
    const handleReviewAction = (param) => {
        let quiz = userReportList.diagnostic.filter((p) => p.quizId === param.quizId);
        setSelected(param);
        setSelectedQuiz(quiz);
        setShowReview(true);
    };
    (0, react_1.useEffect)(() => { }, []);
    (0, react_1.useEffect)(() => {
        getFlaggedQuestions();
    }, [isLoading]);
    const getFlaggedQuestions = () => {
        if (userReportList && userReportList.diagnostic) {
            let diag = userReportList.diagnostic;
            let questions = [];
            diag.map((d) => {
                if (d.flaggedQuestions) {
                    d.flaggedQuestions.forEach((x) => {
                        let que = Object.assign({}, x);
                        if (d.bluebookData) {
                            let arr = d.bluebookData.find((element) => element.questionData.questionNumber === x.questionId && element.questionData.section === x.section);
                            que['linkToModule'] = arr.attributes.LinkToModule;
                        }
                        que['quizId'] = d.quizId;
                        questions.push(que);
                    });
                }
            });
            setQuestionsList(questions);
        }
    };
    const getRowData = () => {
        let questionList = [];
        if (questionsList) {
            let qList = questionsList.sort(({ questionId: a }, { questionId: b }) => a - b);
            qList.map((quest, index) => {
                questionList.push({
                    id: `q-${index + 1}`,
                    questionId: quest.questionId,
                    section: quest.section || '',
                    module: quest.module || '',
                    subType: (quest === null || quest === void 0 ? void 0 : quest.subType) || '',
                    kahnAcademyType: (quest === null || quest === void 0 ? void 0 : quest.kahnAcademyType) || '',
                    type: (quest === null || quest === void 0 ? void 0 : quest.type) || '',
                    difficulty: (quest === null || quest === void 0 ? void 0 : quest.difficulty) || '',
                    flagType: (quest === null || quest === void 0 ? void 0 : quest.flagType) || '',
                    quizId: (quest === null || quest === void 0 ? void 0 : quest.quizId) || '',
                    isBlueBook: quest === null || quest === void 0 ? void 0 : quest.isBlueBook,
                    linkToModule: quest === null || quest === void 0 ? void 0 : quest.linkToModule,
                });
            });
        }
        return questionList;
    };
    const handleClick = async (event, param) => {
        setSelectedParam(param);
        setAnchorEl(event.currentTarget);
    };
    const checkForFlag = (param) => {
        if (param === null || param === void 0 ? void 0 : param.row.flagType) {
            return param === null || param === void 0 ? void 0 : param.row.flagType;
        }
        return 'none';
    };
    const handleTakeTest = (param) => {
        setSelectedTest(param);
        setTakeTestSelected(true);
    };
    const open = Boolean(anchorEl);
    const idpopup = open ? 'simple-popover' : undefined;
    const rows = getRowData();
    const columns = [
        {
            field: 'questionId',
            headerName: 'Question ID',
            maxWidth: 90,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'section',
            headerName: 'Section',
            minWidth: 100,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'module',
            headerName: 'Module',
            minWidth: 100,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'type',
            headerName: 'Alphaprep Type',
            minWidth: 100,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => ((0, jsx_runtime_1.jsx)(material_1.Button, Object.assign({ onClick: (e) => handleGuideClick(params.value), style: { color: 'blue', textTransform: 'none', justifyContent: 'flex-start', textDecoration: 'underline', cursor: 'pointer' } }, { children: params.value }))),
        },
        {
            field: 'subType',
            headerName: 'College Board Domain',
            minWidth: 100,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => ((0, jsx_runtime_1.jsx)(material_1.Button, Object.assign({ onClick: (e) => handleGuideClick(params.value), style: { color: 'blue', textTransform: 'none', justifyContent: 'flex-start', textDecoration: 'underline', cursor: 'pointer' } }, { children: params.value }))),
        },
        {
            field: 'kahnAcademyType',
            headerName: 'Kahn Academy Type',
            minWidth: 100,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'difficulty',
            headerName: 'Difficulty',
            minWidth: 80,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'quizId',
            headerName: 'Quiz ID',
            minWidth: 150,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'flag',
            headerName: 'Flag',
            minWidth: 70,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                let res = checkForFlag(params);
                if (res != 'none') {
                    let flagColor = res === 'help' || res === 'nudge' ? (res === 'help' ? 'red' : 'orange') : '#70D291';
                    return ((0, jsx_runtime_1.jsx)(material_1.Tooltip, Object.assign({ title: res.toUpperCase() }, { children: (0, jsx_runtime_1.jsx)(material_1.Button, Object.assign({ variant: 'contained', sx: { borderRadius: 5, margin: 1, color: 'black', backgroundColor: flagColor, ':hover': { backgroundColor: flagColor } }, onClick: (e) => handleClick(e, params.row) }, { children: (0, jsx_runtime_1.jsx)(FlagOutlined_1.default, {}) })) })));
                }
                else {
                    return ((0, jsx_runtime_1.jsx)(material_1.Button, Object.assign({ variant: 'contained', sx: { borderRadius: 5, margin: 1, color: 'black', backgroundColor: 'white', ':hover': { backgroundColor: 'white' } }, onClick: (e) => handleClick(e, params.row) }, { children: (0, jsx_runtime_1.jsx)(FlagOutlined_1.default, {}) })));
                }
            },
            filterable: true,
            valueGetter: (params) => {
                let res = checkForFlag(params);
                if (res != 'none') {
                    return res;
                }
                else {
                    return '';
                }
            },
        },
        {
            field: 'action',
            headerName: 'Actions',
            headerAlign: 'center',
            minWidth: 150,
            align: 'center',
            renderCell: (params) => {
                if (params.row.isBlueBook) {
                    // Link rendering if isbluebookdata is true
                    return ((0, jsx_runtime_1.jsx)(material_1.Button, Object.assign({ color: 'primary', variant: 'contained', sx: { borderRadius: 20, margin: 1 }, onClick: () => window.open(params.row.linkToModule, '_blank') }, { children: "Link" })));
                }
                else {
                    // Review button rendering if isbluebookdata is false
                    return ((0, jsx_runtime_1.jsx)(material_1.Button, Object.assign({ color: 'primary', variant: 'contained', sx: { borderRadius: 20, margin: 1 }, onClick: () => handleReviewAction(params.row), endIcon: (0, jsx_runtime_1.jsx)(RemoveRedEye_1.default, {}) }, { children: "Review" })));
                }
            },
        },
        {
            field: 'taketest',
            headerName: 'Take Test',
            headerAlign: 'center',
            minWidth: 150,
            align: 'center',
            renderCell: (params) => {
                let res = checkForFlag(params);
                if (res !== 'gotit') {
                    return ((0, jsx_runtime_1.jsx)(material_1.Button, Object.assign({ color: 'primary', variant: 'contained', sx: { borderRadius: 20, margin: 1 }, onClick: () => handleTakeTest(params.row) }, { children: "Take Test" })));
                }
            },
        },
        // {
        // 	field: "guide",
        // 	headerName: "Guide",
        // 	minWidth: 150,
        // 	flex: 1,
        // 	headerAlign: "center",
        // 	align: "center",
        // 	renderCell: (params) => {
        // 		return (
        // 			<Button
        // 				color="primary"
        // 				variant="contained"
        // 				sx={{ borderRadius: 20, margin: 1 }}
        // 				onClick={() => window.open(params.row.linkToModule, "_blank")}
        // 			>
        // 				Guide
        // 			</Button>
        // 		);
        // 	},
        // },
    ];
    const handleClose = () => {
        setAnchorEl(null);
        setSelectedParam([]);
    };
    const [pdfDialogOpen, setPdfDialogOpen] = react_1.default.useState(false);
    const [pdfUrl, setPdfUrl] = react_1.default.useState('');
    const [htmlContent, setHtmlContent] = (0, react_1.useState)('');
    const [fileType, setFileType] = (0, react_1.useState)('');
    const [excelData, setExcelData] = (0, react_1.useState)([]);
    const [typeAnchorEl, setTypeAnchorEl] = react_1.default.useState(null);
    const [selectedType, setSelectedType] = react_1.default.useState('');
    const typeOpen = Boolean(typeAnchorEl);
    const typeIdpopup = typeOpen ? 'type-popover' : undefined;
    const handleGuideClick = async (typeValue) => {
        try {
            //let typeValue = "Vocab in Context";
            //const guide = await getStrapiData(`guides?filters[question_type][Name]][$eqi]=${typeValue}&populate=*`)
            const guide = await (0, shared_1.getStrapiData)(`guides?filters[$or][0][question_type][Name]][$eqi]=${typeValue}&filters[$or][1][area_sub_type][name]][$eqi]=${typeValue}&populate=*`);
            if (guide.length === 0) {
                handleSnackBarOpen('No Guides available', 'error');
            }
            else {
                const pdfPath = guide[0].attributes.Document.data.attributes.url;
                const parts = pdfPath.split('.');
                const extension = parts[parts.length - 1].toLowerCase();
                setFileType(extension);
                const contentAPI = await (0, shared_1.getCmsURL)();
                const fullPdfUrl = `${contentAPI}${pdfPath}`;
                if (extension === 'docx') {
                    const fileResponse = await fetch(fullPdfUrl);
                    const arrayBuffer = await fileResponse.arrayBuffer();
                    const result = await mammoth_1.default.convertToHtml({ arrayBuffer });
                    setHtmlContent(result.value);
                }
                else if (extension == 'pdf') {
                    setPdfUrl(fullPdfUrl);
                    setPdfDialogOpen(true);
                }
                else {
                    try {
                        const response = await fetch(fullPdfUrl);
                        const blob = await response.blob();
                        const arrayBuffer = await blob.arrayBuffer();
                        const workbook = XLSX.read(arrayBuffer, { type: 'array' });
                        const sheetName = workbook.SheetNames[0];
                        const worksheet = workbook.Sheets[sheetName];
                        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                        setExcelData(jsonData);
                    }
                    catch (error) {
                        console.error('Error loading Excel file:', error);
                    }
                }
                console.log('fullPdfUrl ', fullPdfUrl);
                //setPdfUrl(fullPdfUrl);
                setPdfDialogOpen(true);
            }
        }
        catch (error) {
            console.error('Error fetching PDF:', error);
        }
    };
    const handleFlagAction = async (param) => {
        let value = selectedParam;
        value['flagType'] = param;
        setUpdateQuestions((oldArray) => [...oldArray, value]);
        setQuestionsList((prevItems) => {
            const existingItemIndex = questionsList.findIndex((item) => parseInt(item.questionId) === parseInt(selectedParam === null || selectedParam === void 0 ? void 0 : selectedParam.questionId) && item.quizId === selectedParam.quizId && item.section === selectedParam.section);
            const updatedItems = [...prevItems];
            updatedItems[existingItemIndex] = Object.assign({}, value);
            return updatedItems;
        });
        setAnchorEl(null);
    };
    const handleButtonClick = async () => {
        updateQuestions.forEach(async (quest) => {
            let quizId = quest === null || quest === void 0 ? void 0 : quest.quizId;
            await addFlaggedQuestion({ body: { quizId: quizId, flaggedQuestion: quest, mode: '' } })
                .unwrap()
                .then(() => {
                refetch();
            });
        });
        handleSnackBarOpen('Saved Successfully!', 'success');
    };
    const handleSnackBarOpen = (message, type) => {
        setAlertOpen(true);
        setAlertMessage(message);
        setAlertType(type);
    };
    const handleSnackBarClose = () => {
        setAlertOpen(false);
    };
    const handleTypeClick = (event, type) => {
        setSelectedType(type);
        setTypeAnchorEl(event.currentTarget);
    };
    const handleTypeClose = () => {
        setTypeAnchorEl(null);
    };
    const handlePdfDialogClose = () => {
        setPdfDialogOpen(false);
        setPdfUrl('');
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: { width: '100%' } }, { children: [!takeTestSelected ? ((0, jsx_runtime_1.jsxs)(material_1.Stack, Object.assign({ direction: 'column', spacing: 1, width: '100%' }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, Object.assign({ fontWeight: 'bold', fontSize: '2.5vh', style: { paddingTop: '2vh' } }, { children: "Flagged Questions" })), (0, jsx_runtime_1.jsx)(material_1.Paper, Object.assign({ sx: { width: '100%' } }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ style: { height: '78vh', width: '100%', overflowY: 'auto' } }, { children: (0, jsx_runtime_1.jsx)(StyledDataGrid, { rows: rows, columns: columns, hideFooter: true, classes: { columnHeader: 'result_grid_header' }, slots: { toolbar: x_data_grid_1.GridToolbar }, initialState: {
                                    columns: {
                                        columnVisibilityModel: {
                                            quizId: false,
                                        },
                                    },
                                } }) })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, Object.assign({ style: { display: 'flex', justifyContent: 'end', padding: '1vh' } }, { children: (0, jsx_runtime_1.jsx)(material_1.Button, Object.assign({ variant: 'contained', onClick: handleButtonClick }, { children: "Save Changes" })) })), selected && ((0, jsx_runtime_1.jsx)(Review_1.default, { open: showReview, setOpen: () => setShowReview(false), qId: parseInt((selected === null || selected === void 0 ? void 0 : selected.questionId) || 0), questionOrder: parseInt((selected === null || selected === void 0 ? void 0 : selected.questionOrder) || 0), data: selectedQuiz, quiz: 4, header: selected === null || selected === void 0 ? void 0 : selected.module })), isLoading ? ((0, jsx_runtime_1.jsxs)(material_1.Stack, Object.assign({ className: 'wait_stack_dashboard', justifyContent: 'center', alignItems: 'center', spacing: 2 }, { children: [(0, jsx_runtime_1.jsx)(material_1.CircularProgress, { className: 'wait_icon' }), (0, jsx_runtime_1.jsx)(material_1.Typography, Object.assign({ style: { fontFamily: 'PoppinsMedium', fontSize: '1.5vmax', textAlign: 'center', color: 'black' } }, { children: " Please wait ..." }))] }))) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})), (0, jsx_runtime_1.jsx)(material_1.Popover, Object.assign({ id: idpopup, open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'center',
                        }, transformOrigin: {
                            vertical: 'top',
                            horizontal: 'center',
                        } }, { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, Object.assign({ container: true, spacing: 3, justifyContent: 'space-between', sx: { backgroundColor: 'transparent', padding: '2vh' } }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, Object.assign({ item: true, xs: 4, style: { justifyContent: 'center' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.IconButton, { edge: 'end', color: 'inherit', "aria-controls": 'menu', "aria-haspopup": 'true', sx: { width: '3vh', height: '3vh', backgroundColor: 'red', ':hover': { backgroundColor: 'red' } }, onClick: () => {
                                                handleFlagAction('help');
                                            } }), (0, jsx_runtime_1.jsx)(material_1.Typography, Object.assign({ fontWeight: 'bold', textAlign: 'center' }, { children: "Help" }))] })), (0, jsx_runtime_1.jsxs)(material_1.Grid, Object.assign({ item: true, xs: 4 }, { children: [(0, jsx_runtime_1.jsx)(material_1.IconButton, { edge: 'end', color: 'inherit', "aria-controls": 'menu', "aria-haspopup": 'true', sx: { width: '3vh', height: '3vh', backgroundColor: 'orange', ':hover': { backgroundColor: 'orange' } }, onClick: () => {
                                                handleFlagAction('nudge');
                                            } }), (0, jsx_runtime_1.jsx)(material_1.Typography, Object.assign({ fontWeight: 'bold', textAlign: 'center' }, { children: "Nudge" }))] })), (0, jsx_runtime_1.jsxs)(material_1.Grid, Object.assign({ item: true, xs: 4 }, { children: [(0, jsx_runtime_1.jsx)(material_1.IconButton, { edge: 'end', color: 'inherit', "aria-controls": 'menu', "aria-haspopup": 'true', sx: { width: '3vh', height: '3vh', backgroundColor: '#70D291', ':hover': { backgroundColor: '#70D291' } }, onClick: () => {
                                                handleFlagAction('gotit');
                                            } }), (0, jsx_runtime_1.jsx)(material_1.Typography, Object.assign({ fontWeight: 'bold', textAlign: 'center' }, { children: "Got it" }))] }))] })) })), (0, jsx_runtime_1.jsx)(material_1.Snackbar, Object.assign({ autoHideDuration: 6000, onClose: handleSnackBarClose, anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, open: alertOpen }, { children: (0, jsx_runtime_1.jsx)(material_1.Alert, Object.assign({ onClose: handleSnackBarClose, severity: alertType, variant: 'filled', sx: { width: '100%' } }, { children: alertMessage })) }))] }))) : ((0, jsx_runtime_1.jsx)(TestScreen_1.default, { alphaprepType: selectedTest === null || selectedTest === void 0 ? void 0 : selectedTest.type, difficulty: selectedTest === null || selectedTest === void 0 ? void 0 : selectedTest.difficulty, takeTestSelected: takeTestSelected, setTakeTestSelected: setTakeTestSelected })), pdfDialogOpen && ((0, jsx_runtime_1.jsxs)(Dialog_1.default, Object.assign({ open: pdfDialogOpen, onClose: handlePdfDialogClose, maxWidth: 'lg', fullWidth: true }, { children: [(0, jsx_runtime_1.jsx)(DialogTitle_1.default, { children: (0, jsx_runtime_1.jsxs)(material_1.Stack, Object.assign({ direction: 'row', justifyContent: 'space-between', alignItems: 'center' }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, Object.assign({ variant: 'h6' }, { children: "Guide" })), (0, jsx_runtime_1.jsx)(material_1.IconButton, Object.assign({ onClick: handlePdfDialogClose }, { children: (0, jsx_runtime_1.jsx)(Close_1.default, {}) }))] })) }), (0, jsx_runtime_1.jsxs)(DialogContent_1.default, { children: [fileType === 'pdf' && (0, jsx_runtime_1.jsx)("iframe", { src: pdfUrl, width: '100%', height: '600px', title: 'PDF Viewer', style: { border: 'none' } }), fileType === 'docx' && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h3", { children: "DOCX Document" }), (0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: { __html: htmlContent } })] })), fileType === 'xlsx' && ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("table", Object.assign({ style: { border: '1px solid black' } }, { children: (0, jsx_runtime_1.jsx)("tbody", { children: excelData.map((row, rowIndex) => ((0, jsx_runtime_1.jsx)("tr", { children: row.map((cell, colIndex) => ((0, jsx_runtime_1.jsx)("td", Object.assign({ style: { border: '1px solid black' } }, { children: cell }), colIndex))) }, rowIndex))) }) })) }))] })] })))] })));
};
exports.default = FlaggedQuestions;
